import axios from 'axios'

export const state = {
  brands : {},
}

export const getters = {
  listBrands (state) {
    return state.brands
  },
}

export const mutations = {
  SET_BRANDS (state, brands) {
    state.brands = brands
  },
}

export const actions = {
  async getBrands({ commit }, params = {}) {
    const { data } = await axios.get('/brands', { params })
    return commit('SET_BRANDS', data)
  },
  getListBrands({ commit }, params = {}) {
    return axios.get('/brands', { params })
  },
  getBrand({ commit }, id) {
    return axios.get(`/brands/${id}`)
  },
  getBrandRanges({ commit }, { brandId, params = {} }) {
    return axios.get(`/brands/${brandId}/ranges`, { params })
  },
}
